export const localStorageFields = {
  currentUser: 'currentUser',
  language: 'language',
  currency: 'currency',
  deviceSettings: 'deviceSettings',
  groupCallsPopupPosition: 'groupCallsPopupPosition',
  groupCallsMinimizePopupPosition: 'groupCallsMinimizePopupPosition'
} as const
